import { Injectable } from '@angular/core';
import { LoyaltyProgramFacade } from '@features/loyalty-program/facades/loyalty-program.facade';
import { RewardsProgramsFacade } from '@features/rewards-program/facades/rewards-programs.facade';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { LoyaltyProgram } from '@rd/types';
import { RewardsProgram } from '@rd/types/rewards_program.type';
import { getElementBy } from '@rd/utils/getElementBy';
import { isNotNull } from '@rd/utils/isNotNull';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import {
  RewardsProgramSchemes,
  RewardsProgramTransferConnectIdentifier,
} from '../../types';

@Injectable({
  providedIn: 'root',
})
export class RewardsProgramsViewFacade {
  constructor(
    private rewardsProgramFacade: RewardsProgramsFacade,
    private loyaltyProgramFacade: LoyaltyProgramFacade,
    private unleashService: UnleashService,
  ) {}

  partnerRewardsProgram$: Observable<RewardsProgram> =
    this.rewardsProgramFacade.rewardsPrograms$.pipe(
      map((rp) => Object.values(rp)),
      getElementBy(
        (v) =>
          v.loyaltyProgram?.transferConnectIdentifier ===
          RewardsProgramTransferConnectIdentifier.Flybuys,
      ),
      filter(isNotNull),
    );

  partnerLoyaltyProgram$: Observable<LoyaltyProgram> =
    this.partnerRewardsProgram$.pipe(
      switchMap((rp) =>
        this.loyaltyProgramFacade.loyaltyPrograms$.pipe(
          getElementBy(rp.loyaltyProgramId),
          filter(isNotNull),
        ),
      ),
    );

  tenantRewardsProgram$: Observable<RewardsProgram> =
    this.rewardsProgramFacade.rewardsPrograms$.pipe(
      map((rp) => Object.values(rp)),
      getElementBy(
        (rp) =>
          rp.loyaltyProgram?.transferConnectIdentifier ===
          RewardsProgramTransferConnectIdentifier.Bnz,
      ),
      filter(isNotNull),
    );

  selectedScheme$: Observable<RewardsProgramSchemes> =
    this.rewardsProgramFacade.rewardsProgramPreferenceFailed$.pipe(
      switchMap((isError) => of(RewardsProgramSchemes.Bnz)),
    );
}
